import { useEffect } from 'react';

/**
 * Hook to fix background image white space on mobile
 * Call this hook in any component that has a fixed background
 * @param {string} backgroundId - The ID of the background element
 * @param {Array} dependencies - Dependencies that should trigger height recalculation
 */
export function useBackgroundFix(backgroundId, dependencies = []) {
  useEffect(() => {
    const updateBackgroundHeight = () => {
      if (window.innerWidth <= 767) {
        const bgElement = document.getElementById(backgroundId);
        if (bgElement) {
          // Set height to match document scroll height
          const docHeight = Math.max(
            document.body.scrollHeight,
            document.body.offsetHeight,
            document.documentElement.clientHeight,
            document.documentElement.scrollHeight,
            document.documentElement.offsetHeight
          );
          bgElement.style.height = `${docHeight}px`;
        }
      }
    };

    // Update on mount and resize
    updateBackgroundHeight();
    window.addEventListener('resize', updateBackgroundHeight);
    window.addEventListener('scroll', updateBackgroundHeight);
    
    // Also update after a short delay to account for content loading
    const timeoutId = setTimeout(updateBackgroundHeight, 100);
    const intervalId = setInterval(updateBackgroundHeight, 500); // Update periodically

    return () => {
      window.removeEventListener('resize', updateBackgroundHeight);
      window.removeEventListener('scroll', updateBackgroundHeight);
      clearTimeout(timeoutId);
      clearInterval(intervalId);
    };
  }, dependencies);
}

